import React from 'react';
import { FadeIn } from './FadeIn';
const testimonials = [{
  name: 'Martín L.',
  role: '24 años, estudiante de kinesiología, Buenos Aires',
  text: 'Antes de leer el libro, ponía la cinta rezando para que funcione. Ahora entiendo exactamente por qué elijo cada corte y tensión. Me dio la confianza que me faltaba para mis primeras prácticas.',
  initial: 'M'
}, {
  name: 'Camila R.',
  role: '29 años, kinesióloga, Córdoba',
  text: 'La claridad del razonamiento clínico es oro puro. Dejé de copiar técnicas de YouTube y empecé a pensar en el objetivo real del vendaje para cada paciente. Cambió mi forma de trabajar.',
  initial: 'C'
}, {
  name: 'Facundo G.',
  role: '32 años, entrenador personal, Rosario',
  text: 'Como entrenador, saber aplicar tape con criterio me diferenció muchísimo de otros profes. Mis alumnos notan la diferencia y se sienten mucho más cuidados cuando hay una sobrecarga.',
  initial: 'F'
}, {
  name: 'Lucía M.',
  role: '26 años, estudiante avanzada, Mendoza',
  text: 'El libro va directo al grano. Los casos reales son exactamente lo que vemos todos los días. Dejé de dudar frente al paciente y ahora sé qué esperar después de cada aplicación.',
  initial: 'L'
}, {
  name: 'Santiago P.',
  role: '35 años, kinesiólogo, La Plata',
  text: 'Compré muchos cursos caros que eran pura teoría aburrida. Este sistema es 100% práctico. Te da independencia real para tomar decisiones clínicas rápidas y efectivas en el consultorio.',
  initial: 'S'
}];
export function Testimonials() {
  return <section className="py-10 px-4 bg-slate-800/30" data-id="element-323">
      <div className="max-w-6xl mx-auto" data-id="element-324">
        <FadeIn data-id="element-325">
          <div className="text-center mb-10" data-id="element-326">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-327">
              Profesionales que ya dejaron de dudar
            </h2>
            <p className="text-lg md:text-xl text-slate-400" data-id="element-328">
              Resultados reales de personas que ya aplican el sistema.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-329">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} className={i === 3 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : i === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-3' : ''} data-id="element-330">
              <div className="bg-slate-800 border border-slate-700 p-6 rounded-2xl h-full flex flex-col relative" data-id="element-331">
                <div className="absolute top-6 right-6 text-4xl text-slate-700 font-serif" data-id="element-332">
                  "
                </div>
                <div className="flex items-center mb-4" data-id="element-333">
                  <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xl mr-4 shadow-lg" data-id="element-334">
                    {t.initial}
                  </div>
                  <div data-id="element-335">
                    <h4 className="text-white font-bold" data-id="element-336">{t.name}</h4>
                    <p className="text-sm text-slate-400" data-id="element-337">{t.role}</p>
                  </div>
                </div>
                <div className="flex mb-4" data-id="element-338">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-339">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-340" />
                    </svg>)}
                </div>
                <p className="text-slate-300 italic flex-grow relative z-10" data-id="element-341">
                  "{t.text}"
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}